import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaBancosLayoutBanco', {
    template: template,
    controller: NominasNominaBancosLayoutBancoComponent,
    bindings: {
      data: '<',
      generador: '<',
    },
  })

function NominasNominaBancosLayoutBancoComponent($q) {
  let $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.omitirInvalidos = omitirInvalidos
  $ctrl.seleccionar = seleccionar
  $ctrl.generar = generar

  function $onInit() {
    $ctrl.validos = undefined
    $ctrl.invalidos = undefined
    $ctrl.seleccionados = []
    $ctrl.generando = false
    $ctrl.fecha = new Date()
    $ctrl.data = $ctrl.data || []

    $ctrl.validos = $ctrl.data.filter(function (item) {
      return item.Valido
    })

    $ctrl.invalidos = $ctrl.data.filter(function (item) {
      return !item.Valido
    })
  }

  function omitirInvalidos() {
    $ctrl.invalidos = []
  }

  function seleccionar(items) {
    $ctrl.seleccionados = items
  }

  function generar() {
    $ctrl.generando = true
    $q.when($ctrl.generador($ctrl.seleccionados))
      .finally(function () {
        $ctrl.generando = false
      })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/layout/banco/component.js